/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
class t{constructor(t,i){this.definition=null,this.context=null,this.definition=t,this.context=i}}export{t as default};
